export default function publishMiddleware(publish, actionTypes = []) {
  return () => next => action => {
    if (actionTypes.indexOf(action.type) > -1) {
      publish('action', action);
    }
    return next(action);
  };
}



// WEBPACK FOOTER //
// ./app/middleware/publish-middleware.js